import { Typography, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';

const TitleArea = () => {
  const { t } = useTranslation('common');
  const theme = useTheme();

  return (
    <Box
      sx={{
        pt: 6,
        backgroundColor: theme.palette.primary[700],
      }}
    >
      <Box
        sx={{
          width: '100%',
          backgroundColor: theme.palette.common.white,
          pt: { xs: 6, sm: 9 },
          pb: 7,
          pl: { xs: 6, sm: 9 },
          pr: 6,
          borderRadius: { xs: '0px', sm: '40px 0px 0px 0px' },
        }}
      >
        <Box
          sx={{
            color: theme.palette.common.black,
            display: 'flex',
            alignItems: 'flex-start',
            alignContent: 'flex-start',
            gap: '10px 8px',
            alignSelf: 'stretch',
            flexWrap: 'wrap',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              minWidth: '220px',
              p: 0,
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: 2,
              flex: '1 0 0',
            }}
          >
            <Typography
              sx={{
                color: theme.palette.custom.gray[900],
                fontSize: '30px',
                fontStyle: 'normal',
                fontWeight: 600,
                lineHeight: '38px',
                textAlign: 'left',
              }}
            >
              {t('welcomeBack')}, 👋
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              p: 0,
              alignItems: 'center',
              gap: 5,
              width: { xs: '100%', sm: '300px' },
            }}
          >
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={theme.spacing(5)}
              sx={{ width: '100%' }}
            >

            </Stack>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TitleArea;
